import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=24cbe53f&scoped=true&"
import script from "./follow.vue?vue&type=script&lang=js&"
export * from "./follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbe53f",
  null
  
)

export default component.exports